__turbopack_context__.v({
  "summaryMetricFullWidth": "summary-metrics-module__Gx48da__summaryMetricFullWidth",
  "summaryMetrics": "summary-metrics-module__Gx48da__summaryMetrics",
  "summaryMetricsGrid": "summary-metrics-module__Gx48da__summaryMetricsGrid",
  "summaryMetricsGridSingle": "summary-metrics-module__Gx48da__summaryMetricsGridSingle",
  "summaryMetricsGridWide": "summary-metrics-module__Gx48da__summaryMetricsGridWide",
});
